import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkUpdateSmokerRateStatusByIds } from '../../../api/plan-smoker-rate-override-rules-api'
import type { BulkUpdateSmokerRateStatusByIdsRequestDto } from '../../../api/dto/plan-smoker-rate-override-rules.dto'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'

export function useBulkUpdateSmokerRateStatusByIds() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, BulkUpdateSmokerRateStatusByIdsRequestDto>({
    mutationFn: (body) => bulkUpdateSmokerRateStatusByIds(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
